import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/BenefitsSetCsvExports'
import connectIndex from '../../lib/connectIndex'
import withRouter from '../../lib/withRouter'

export class BenefitsSetCsvExportIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    filters: PropTypes.array,
    flashMessages: PropTypes.array.isRequired,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
  }

  static columns = [
    { key: 'product_line', label: 'Export Type', sortable: false },
    { key: 'username', label: 'User', sortable: false },
    { key: 'query', label: 'Query', sortable: false },
    { key: 'state', label: 'State', sortable: false },
    { key: 'expires', label: 'Expires', sortable: false },
    { key: 's3_path', label: 'S3 Path', sortable: false, display: BenefitsSetCsvExportIndex.showAwsLink }
  ]

  static showAwsLink = (record) => {
    return <a target="_blank" rel="noopener noreferrer" href={record.s3_path}>{record.s3_prefix}{record.filename}</a>
  }

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/benefits_set_csv_exports"
          name="Benefits Set CSV Exports"
          pagination={this.props.pagination}
          columns={BenefitsSetCsvExportIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          includeNewRecordLink={false}
          includeBulkActionLink={false}
          includeSearch={false}
          actions={[]}
          history={this.props.history}
        />
      </div>
    )
  }
}

const filters = []

export default connectIndex(withRouter(BenefitsSetCsvExportIndex), 'benefitsSetCsvExports', actions, filters)
